import { VAlert } from 'vuetify/lib/components/VAlert';
import { VAvatar } from 'vuetify/lib/components/VAvatar';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCheckbox } from 'vuetify/lib/components/VCheckbox';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VTreeview } from 'vuetify/lib/components/VTreeview';

var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c(VContainer, {
    staticClass: "pa-0 n20-container",
    attrs: {
      "fluid": "",
      "data-cy": "virtual_device_container"
    }
  }, [_c('core-prompt', {
    attrs: {
      "title": _vm.$i18n_t('DigitalTwin.VirtualDevice.deviceDeleteConfirmation'),
      "open": _vm.deletePrompt,
      "buttons": [{
        text: _vm.$i18n_t('Common.close'),
        emit: 'cancel'
      }, {
        text: _vm.$i18n_t('DigitalTwin.DigitalTwin.twinDelete'),
        color: 'red',
        emit: 'delete',
        disabled: _vm.deviceDependencies === null || !_vm.canDeleteDevice || _vm.deleteDialog
      }],
      "color": "red",
      "data-cy": "delete_prompt"
    },
    on: {
      "cancel": function ($event) {
        _vm.deletePrompt = false;
      },
      "delete": function ($event) {
        return _vm.deleteDevice(_vm.deviceObject);
      }
    }
  }, [(_vm.get(_vm.deviceDependencies, 'aggregatedStates') || []).length ? [_vm._v("\n      " + _vm._s(_vm.$i18n_t('DigitalTwin.VirtualDevice.deviceDeleteCannotDeleteText')) + "\n      "), _c(VTreeview, {
    staticClass: "mt-2 infoTree",
    attrs: {
      "items": _vm.deviceDependencies.aggregatedStates,
      "item-key": "id"
    },
    scopedSlots: _vm._u([{
      key: "prepend",
      fn: function ({
        item
      }) {
        return [item.icon ? _c(VIcon, {
          staticStyle: {
            "width": "25px"
          },
          attrs: {
            "size": "16"
          },
          domProps: {
            "textContent": _vm._s(`fal fa-${item.icon}`)
          }
        }) : _vm._e()];
      }
    }, {
      key: "label",
      fn: function ({
        item
      }) {
        return [item.isTwin ? [_c('a', {
          attrs: {
            "href": `/#/${item.twinType === 'virtualDevice' ? 'virtual-devices' : 'digitaltwin-mgmt'}/${item.id}`,
            "target": "_blank"
          }
        }, [_vm._v("\n              " + _vm._s(item.title) + "\n            ")])] : [_vm._v("\n            " + _vm._s(item.title) + "\n          ")], _vm._v("\n           \n          "), item.id ? _c('span', {
          staticStyle: {
            "font-size": "10px"
          }
        }, [_vm._v("(" + _vm._s(_vm.$i18n_t('Common.id')) + ": " + _vm._s(item.id) + ")")]) : _vm._e()];
      }
    }], null, false, 1373246036)
  })] : _vm._e(), _vm.showDeleteExternalService(_vm.deviceObject) ? [_vm._v("\n      " + _vm._s(_vm.$i18n_t('DigitalTwin.VirtualDevice.deviceDeleteConfirmText')) + "\n      "), _c(VCheckbox, {
    attrs: {
      "color": _vm.color,
      "label": _vm.$i18n_t('DigitalTwin.VirtualDevice.deviceDeleteRemotely')
    },
    model: {
      value: _vm.deviceDeleteRemotely,
      callback: function ($$v) {
        _vm.deviceDeleteRemotely = $$v;
      },
      expression: "deviceDeleteRemotely"
    }
  })] : _vm._e(), _vm.deleteDialog ? [_vm._v("\n      " + _vm._s(_vm.$i18n_t('DigitalTwin.VirtualDevice.snacks.deletionInProgress')) + "\n      "), _c(VCardText, {
    staticClass: "mt-2 text-center"
  }, [_c(VProgressCircular, {
    attrs: {
      "indeterminate": "",
      "color": _vm.color
    }
  })], 1)] : _vm._e()], 2), _c(VRow, {
    class: _vm.containerClass,
    staticStyle: {
      "min-width": "0"
    },
    attrs: {
      "data-cy": "virtual_device_row"
    }
  }, [_c(VCol, {
    staticClass: "pa-0"
  }, [_vm.isEmptyList ? _c('core-n20Card', [_c('core-empty-state', {
    attrs: {
      "icon": "fa-sensor-on",
      "color": _vm.color
    },
    scopedSlots: _vm._u([{
      key: "title",
      fn: function () {
        return [_vm._v("\n            " + _vm._s(_vm.$i18n_t('DigitalTwin.VirtualDevice.emptyState.title')) + "\n          ")];
      },
      proxy: true
    }, {
      key: "button",
      fn: function () {
        return [_c('core-button', {
          staticClass: "mt-4",
          attrs: {
            "color": _vm.color,
            "append-icon": "fa-arrow-right"
          },
          on: {
            "click": _vm.showParentsCreateDialog
          }
        }, [_vm._v("\n              " + _vm._s(_vm.$i18n_t('DigitalTwin.VirtualDevice.emptyState.button')) + "\n            ")])];
      },
      proxy: true
    }], null, false, 2267038775)
  }, [_c('p', [_vm._v("\n            " + _vm._s(_vm.$i18n_t('DigitalTwin.VirtualDevice.emptyState.description')) + "\n          ")])])], 1) : _c('core-n20Card', [_c('MultiSearch', {
    ref: "multiSearch",
    attrs: {
      "data-cy": "multi-search",
      "search-config": _vm.searchConfig,
      "show-condition": "",
      "show-operator": "",
      "dense": ""
    },
    on: {
      "search-updated": _vm.onSearchUpdate
    }
  }), _c('div', {
    staticStyle: {
      "text-align": "right"
    }
  }, [_c('custom-table-column-select', {
    attrs: {
      "items": _vm.customizableColumns,
      "max-height": "300",
      "min-width": "200",
      "data-cy": "column_select"
    },
    on: {
      "update": _vm.handleColumnUpdate
    }
  })], 1), _c(VDataTable, {
    staticClass: "row-pointer",
    attrs: {
      "data-cy": "virtual_device_data_table",
      "items": _vm.list,
      "loading": _vm.isFetching,
      "server-items-length": _vm.serverItemsLength,
      "options": _vm.tableOptions,
      "headers": _vm.computedVisibleHeaders,
      "footer-props": _vm.tableFooterProps,
      "header-props": {
        sortIcon: 'pl-1 pr-1 fa fa-sort-up'
      },
      "single-select": false,
      "show-select": "",
      "item-key": "id",
      "page": _vm.tableOptions.page,
      "data-cy-state": _vm.isFetching ? 'loading' : 'loaded'
    },
    on: {
      "update:options": function ($event) {
        _vm.tableOptions = $event;
      },
      "update:page": function ($event) {
        return _vm.$set(_vm.tableOptions, "page", $event);
      },
      "input": function ($event) {
        return _vm.setSelected($event);
      }
    },
    scopedSlots: _vm._u([{
      key: "item.selected",
      fn: function ({
        item
      }) {
        return [_c(VCheckbox, {
          attrs: {
            "primary": "",
            "hide-details": "",
            "input-value": item.selected
          }
        })];
      }
    }, {
      key: "item.icon",
      fn: function ({
        item
      }) {
        return [_c(VIcon, {
          attrs: {
            "color": _vm.color
          }
        }, [_vm._v("\n              " + _vm._s(item.data.faIcon ? `fal fa-${item.data.faIcon}` : 'fal fa-sensor-on') + "\n            ")])];
      }
    }, {
      key: "item.createdAt",
      fn: function ({
        item
      }) {
        return [_vm._v("\n            " + _vm._s(_vm.localizeDate(item.createdAt)) + "\n          ")];
      }
    }, {
      key: "item.updatedAt",
      fn: function ({
        item
      }) {
        return [_vm._v("\n            " + _vm._s(_vm.localizeDate(item.updatedAt)) + "\n          ")];
      }
    }, {
      key: "item.id",
      fn: function ({
        item
      }) {
        return [_c('div', {
          staticStyle: {
            "min-width": "30px"
          },
          attrs: {
            "title": item.id
          }
        }, [_c('router-link', {
          attrs: {
            "to": `/virtual-devices/${item.id}`
          }
        }, [_vm._v("\n                " + _vm._s(item.id) + "\n              ")])], 1)];
      }
    }, {
      key: "item.tenant.name",
      fn: function ({
        item
      }) {
        return [_vm._v("\n            " + _vm._s((item.tenant || {}).name) + "\n          ")];
      }
    }, {
      key: "item.title",
      fn: function ({
        item
      }) {
        return [_c('div', {
          staticClass: "text-truncate",
          attrs: {
            "title": item.title
          }
        }, [_c('router-link', {
          attrs: {
            "to": `/virtual-devices/${item.id}`
          }
        }, [_vm._v("\n                " + _vm._s(item.title) + "\n              ")])], 1)];
      }
    }, {
      key: "item.bridge.type",
      fn: function ({
        item
      }) {
        return [_vm.bridgeTypesIcons[item.properties.bridge.type] ? _c('router-link', {
          attrs: {
            "to": `/connectors/edit/${item.tenantId}/${item.properties.bridge.configId}`
          }
        }, [_vm.bridgeTypesIcons[item.properties.bridge.type] ? _c(VAvatar, {
          staticStyle: {
            "border-radius": "25%"
          },
          attrs: {
            "size": "32"
          }
        }, [_c('img', {
          attrs: {
            "src": _vm.bridgeTypesIcons[item.properties.bridge.type],
            "alt": item.properties.bridge.type.replace(/^bridge\-/gi, ''),
            "title": item.properties.bridge.type.replace(/^bridge\-/gi, '')
          }
        })]) : _vm._e()], 1) : _c('div', [_vm._v("-")])];
      }
    }, _vm.featureFlagDeviceTypeFallbackEnabled ? {
      key: "item.deviceType",
      fn: function ({
        item
      }) {
        return [_c('div', {
          staticClass: "truncate",
          staticStyle: {
            "min-width": "100px"
          },
          attrs: {
            "title": (item.deviceType || {}).title
          }
        }, [_c('router-link', {
          staticStyle: {
            "color": "inherit"
          },
          attrs: {
            "to": `/niota-classic/device-types/${item.deviceType.id}/details`
          }
        }, [_vm._v("\n                " + _vm._s((item.deviceType || {}).title) + "\n              ")])], 1)];
      }
    } : {
      key: "item.deviceDriver",
      fn: function ({
        item
      }) {
        return [_c('div', {
          staticClass: "truncate",
          staticStyle: {
            "min-width": "100px"
          },
          attrs: {
            "title": (item.deviceDriver || {}).title
          }
        }, [_c('router-link', {
          staticStyle: {
            "color": "inherit"
          },
          attrs: {
            "to": `/virtual-device-drivers/${item.deviceDriver.id}`
          }
        }, [_vm._v("\n                " + _vm._s((item.deviceDriver || {}).title) + "\n              ")])], 1)];
      }
    }, {
      key: "item.deviceTemplate",
      fn: function ({
        item
      }) {
        return [_c('div', {
          staticClass: "truncate",
          staticStyle: {
            "min-width": "100px"
          },
          attrs: {
            "title": (item.deviceTemplate || {}).title
          }
        }, [_c('router-link', {
          staticStyle: {
            "color": "inherit"
          },
          attrs: {
            "to": `/device-templates/${item.deviceTemplate.id}`
          }
        }, [_vm._v("\n                " + _vm._s((item.deviceTemplate || {}).title) + "\n              ")])], 1)];
      }
    }, {
      key: "item.lastSeen",
      fn: function ({
        item
      }) {
        return [_c('span', {
          attrs: {
            "title": _vm.localizeDate(item.lastSeen)
          }
        }, [_vm._v(_vm._s(_vm.relativeTime(item.lastSeen)))])];
      }
    }, {
      key: "item.deviceId",
      fn: function ({
        item
      }) {
        return [_c('custom-copy-clipboard', {
          attrs: {
            "content": item.properties.bridge.deviceData.device_id,
            "full-width": ""
          }
        })];
      }
    }, {
      key: "item.operationalStatus",
      fn: function ({
        item
      }) {
        return [item.data && item.data.virtualDevice ? _c('div', [_c('core-virtual-device-operational-status', {
          attrs: {
            "value": item.data.virtualDevice.operationalStatus
          }
        })], 1) : _vm._e()];
      }
    }, {
      key: "item.health",
      fn: function ({
        item
      }) {
        return [_c('core-virtual-device-health-status-column', {
          attrs: {
            "item": item
          }
        })];
      }
    }, {
      key: "item.actions",
      fn: function ({
        item
      }) {
        return [_c('router-link', {
          staticStyle: {
            "margin-right": "6px"
          },
          attrs: {
            "to": `/virtual-devices/${item.id}`,
            "data-cy": "edit_btn"
          }
        }, [_c(VIcon, {
          attrs: {
            "color": _vm.color,
            "title": _vm.$i18n_t('Common.edit'),
            "small": ""
          }
        }, [_vm._v("\n                fal fa-" + _vm._s(_vm.isVirtualDeviceManager ? 'edit' : 'eye') + "\n              ")])], 1), _vm.isVirtualDeviceManager ? _c(VIcon, {
          attrs: {
            "color": _vm.color,
            "title": _vm.$i18n_t('Common.delete'),
            "small": ""
          },
          on: {
            "click": function ($event) {
              return _vm.showDeletePrompt(item);
            }
          }
        }, [_vm._v("\n              fal fa-trash-alt\n            ")]) : _vm._e()];
      }
    }, {
      key: "footer.page-text",
      fn: function (items) {
        return [_c(VRow, {
          staticClass: "text-center align-center"
        }, [_c(VCol, {
          attrs: {
            "cols": "7",
            "md": "7"
          }
        }, [_vm._v("\n                " + _vm._s(items.pageStart) + "-" + _vm._s(items.pageStop) + " " + _vm._s(_vm.$i18n_t('Common.of')) + "\n                " + _vm._s(items.itemsLength) + "\n              ")]), _c(VCol, {
          attrs: {
            "cols": "5",
            "md": "5"
          }
        }, [_c('niota-classic-common-table-page-selector', {
          attrs: {
            "page": _vm.tableOptions.page,
            "table-max-items": _vm.serverItemsLength,
            "table-items-per-page": _vm.tableOptions.itemsPerPage,
            "title-txt": _vm.$i18n_t('Common.goToPage')
          },
          on: {
            "page-change": function ($event) {
              return _vm.setCurrentTablePage($event);
            }
          }
        })], 1)], 1)];
      }
    }, {
      key: "no-data",
      fn: function () {
        return [_c(VAlert, {
          staticClass: "mb-1",
          attrs: {
            "value": true,
            "color": "transparent",
            "icon": "fal fa-comment-exclamation"
          }
        }, [_vm._v("\n              " + _vm._s(_vm.$i18n_t('Common.SorryNothingToDisplay')) + "\n            ")])];
      },
      proxy: true
    }], null, true),
    model: {
      value: _vm.selected,
      callback: function ($$v) {
        _vm.selected = $$v;
      },
      expression: "selected"
    }
  })], 1)], 1)], 1)], 1);
};
var staticRenderFns = [];
export { render, staticRenderFns };